import React, { useEffect, useRef, useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Col, FormGroup, Label, Button } from "reactstrap";
import { Field } from "formik";
import Barcode from "react-barcode";
import { useReactToPrint } from "react-to-print";
import { ProductInfoEdit } from "../../../contents/htmlContent";
import { ComonIcons } from "../../../contents/commonIcons";
import { checkBarcodesUnique } from "../../../redux/actions/api/apiAction";
import { useDispatch } from "react-redux";
import { store } from "../../../redux/storeConfig/store";
import debounce from "lodash.debounce";
import { toastr } from "react-redux-toastr";

export const BarcodeSection = ({
  errors,
  touched,
  values,
  setFieldValue,
  edit,
}) => {

  const [counter, setCounter] = useState([0]);
  const [barcodeErrors, setBarcodeErrors] = useState({});
  const dispatch = useDispatch();
  const generateBarcode = () => {
    /**
     * we have array of barcodes [111,222,333] product.barcode
     *  will have a counter =1
     *  check if counter show input of barcode onChange product.barcode[counter-1]=e.target.value
     *  check if product.barcode [counter-1]
     *    -- show image  product.barcode[counter-1]
     *   check if i  ==1
     *    -- show the 3 buttons
     * for each barcode their is an image
     * there are three buttons (add,generate,scan)
     *   -- if add :
     *     -- a new row will be generated and image next to it and counter will be increased
     *   -- if generate
     *     -- product.barcode[counter-1]=generateBarcode()
     *
     */
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const length = 13; // You can adjust the length of the barcode as per your requirement
    let barcode = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      barcode += characters[randomIndex];
    }

    return barcode;
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (values.barcode && values?.barcode.length) {
      let counterArr = [];
      values.barcode.map((el, ind) => {
        counterArr.push(ind);
      });
      setCounter(counterArr);
    }
  }, [values]);

  const checkUnique = useRef(
    debounce(async (value, index) => {
      if (!value) return;

      await dispatch(checkBarcodesUnique({ barcodes: [value] }));

      const { duplicates } = store.getState().product.barcodeValidations || { duplicates: [] };
      const found = duplicates.find((d) => d.code === value);

      setBarcodeErrors((prev) => {
        const copy = { ...prev };
        if (found) {
          toastr.error(`Barcode (${found.code}) already used in Product: (${found.productName})`);
          copy[index] = `Barcode (${found.code}) already used in Product: (${found.productName})`;
        } else {
          delete copy[index];
        }
        return copy;
      });
    }, 500)
  ).current;

  const handleInputChange = (e, index) => {
    const val = e.target.value;
    const barcodes = [...values.barcode];
    barcodes[index] = val;
    setFieldValue("barcode", barcodes);

    checkUnique(val, index);
  };

  const addBarcodeRow = () => setCounter((prev) => [...prev, prev[prev.length - 1] + 1]);

  const deleteBarcodeRow = (index) => {
    const updatedBarcodes = [...values.barcode];
    updatedBarcodes.splice(index, 1);
    setFieldValue("barcode", updatedBarcodes);

    const updatedCounter = [...counter];
    updatedCounter.splice(index, 1);
    setCounter(updatedCounter);

    // Also remove any existing error for this index
    setBarcodeErrors((prev) => {
      const copy = { ...prev };
      delete copy[index];
      return copy;
    });
  };

  return (
    <>
      {counter.map((count) => {
        const currentValue = values?.barcode?.[count] || null;
        const errorMsg = barcodeErrors[count];

        return (
          <React.Fragment key={count}>
            <Col md={values?.barcode && values?.barcode[count] ? 3 : 6}>
              <FormGroup className="custom-inputs ">
                <Field
                  type="text"
                  value={currentValue}
                  id={count}
                  maxLength={13}
                  placeholder={ProductInfoEdit.barcodePlaceHolder}
                  className={`form-control ${errorMsg ? "is-invalid" : ""}`}
                  onChange={(e) => handleInputChange(e, count)}
                />
                {errorMsg && <div className="invalid-feedback">{errorMsg}</div>}
                {errors.barcode && touched.barcode && !errorMsg && (
                  <div className="invalid-feedback">{errors.barcode}</div>
                )}
                <Label for="barcode">{ProductInfoEdit.barcode}</Label>
              </FormGroup>
            </Col>

            {currentValue ? (
              <Col md={3} className="mt-n2 ml-n4 ">
                <Barcode
                  value={currentValue}
                  height="50"
                  width={1.5}
                />
              </Col>
            ) : null}
            {currentValue ? (
              <Col md={1} className="mr-4 barcode-container">
                <div onClick={handlePrint} className="print-icon">
                  {ComonIcons.download}
                  <div style={{ display: "none" }}>
                    {/* This component won't be displayed */}
                    <div ref={componentRef}>
                      {values?.barcode &&
                        values?.barcode.map((barcodeValue, index) => (
                          <div className="barcode-container">
                            {/* Render your Barcode component here */}
                            <Barcode
                              value={barcodeValue}
                              height={50}
                              width={1.5}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </Col>
            ) : null}

            {count == 0 ? (
              <Col md={5}>
                <Button
                  onClick={addBarcodeRow} className="mr-2">Add Barcode</Button>
                <Button
                  className="mr-2"
                    onClick={() => {
                      const barcodes = [...values.barcode];
                      const generated = generateBarcode();
                      barcodes[count] = generated;
                      setFieldValue("barcode", barcodes);
                      checkUnique(generated, count);
                  }}
                >
                  Generate Barcode
                </Button>
              </Col>
              ) : (
              <Col md={5}>
                <Button
                 onClick={() => deleteBarcodeRow(count)}        className={"mr-2"}
                >
                  Delete Barcode</Button>
                <Button
                  className="mr-1"
                  onClick={() => {
                      const barcodes = [...values.barcode];
                      const generated = generateBarcode();
                      barcodes[count] = generated;
                      setFieldValue("barcode", barcodes);
                      checkUnique(generated, count);
                  }}
                >
                  Generate Barcode
                </Button>
              </Col>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};
